import React, { useEffect, useRef, useState } from 'react';
import DefaultButton from '../default-button/default-button';
import './editable-area.scss';
import classnames from 'classnames';

interface IProps {
    content: string;
    onSave: (content: string) => void;
    validator: (content: string) => string | object | null;
    shouldSaveOnBlur?: boolean;
    onBlur?: () => void;
}

const EditableArea = (props: IProps) => {
    const {
        content,
        onSave,
        validator,
        shouldSaveOnBlur = false,
        onBlur
    } = props;
    const [dirtyValue, setDirtyValue] = useState(content || '');
    const [isReadonly, setIsReadonly] = useState(true);

    const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setDirtyValue(e.target.value);
    };
    const onSaveHandler = () => {
        if (!validator(dirtyValue)) {
            onSave(dirtyValue);
            setIsReadonly(true);
        }
    };

    const onCancel = () => {
        setDirtyValue(content || '');
        setIsReadonly(true);
    };

    const openForEditing = () => {
        if (isReadonly) {
            setDirtyValue(content || '');
            setIsReadonly(false);
        }
    };



    const wrapperRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                if (shouldSaveOnBlur && content !== dirtyValue) {
                    onSaveHandler();
                }
                onBlur?.();
            }
        }
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [wrapperRef, dirtyValue, content]);

    const errorMessage = validator(dirtyValue);

    return (
      <div className='read-only-textarea' ref={wrapperRef}>
          <textarea
              className={classnames(['oe-form-field__control', 'read-only-textarea__textarea'], {
                  'read-only-textarea__textarea--readonly': isReadonly
              })}
              onClick={openForEditing}
              value={isReadonly ? content : dirtyValue}
              onChange={onChange}
              readOnly={isReadonly}
              placeholder='Notes'
          />
          { errorMessage && <div className='read-only-textarea__error'>{errorMessage}</div> }
          <div className={classnames('read-only-textarea__controls', {
              'read-only-textarea__controls--readonly': isReadonly
          })}>
              <DefaultButton
                  modifier='cancel'
                  text='Cancel'
                  onClick={onCancel}
                  className='read-only-textarea__controls-button'
              />
              <DefaultButton
                  modifier='confirm-safe'
                  text='Save'
                  onClick={onSaveHandler}
                  className='read-only-textarea__controls-button'
              />
          </div>
      </div>
    );
};

export { EditableArea };